import { isNil } from "@etudescarre/utils";
import { useEffect, useState } from "react";
import { toaster } from "@/app";
import { apiClient } from "@/lib/api/client";
import type { paths } from "@/lib/api/schema";

export type ReceptionEmetteur =
  paths["/api/yards/{yardId}/receptions/emetteurs"]["get"]["responses"][200]["content"]["application/json"]["data"]["contracts"][number];

/**
 * Contracts the user may register a reception for: its own, and those linked
 * to an intervention it pilots. The server enforces the same list. Pass a null
 * yard id to skip the request.
 */
export function useReceptionEmetteurs(yardId: number | null) {
  const [emetteurs, setEmetteurs] = useState<ReceptionEmetteur[]>([]);

  useEffect(() => {
    if (isNil(yardId)) return;
    let cancelled = false;
    apiClient
      .GET("/api/yards/{yardId}/receptions/emetteurs", {
        params: { path: { yardId: String(yardId) } },
      })
      .then(({ data, error }) => {
        if (cancelled) return;
        if (error || isNil(data)) {
          throw new Error("Failed to load reception emetteurs");
        }
        setEmetteurs(data.data.contracts);
      })
      .catch((error) => {
        if (cancelled) return;
        console.error("Failed to load reception emetteurs", error);
        toaster.error({
          title: "Erreur",
          description: "Impossible de charger les émetteurs",
        });
      });
    return () => {
      cancelled = true;
    };
  }, [yardId]);

  return emetteurs;
}
